<template>
	<div class="pagination">
		<template v-if="pageCount > 1">
			<button class="arrow-btn arrow-btn-prev" :class="{disable: !hasPrevPage}" @click.prevent="onPageClick(value - 1)">
				<img class="inject-me" src="/assets/img/icons/arrow-left.svg" alt="arrow-left">
			</button>

			<ul class="pagination-num">
				<li class="pagination-num-item" v-if="hasFirst()">
					<a href="#" class="inner" @click.prevent="onPageClick(1)">1</a>
				</li>
				<li class="pagination-num-item" v-if="hasFirst()">...</li>

				<li v-for="n in pages" :key="n" class="pagination-num-item" :class="{active: n == value}">
					<a :href="getUrl(n)" class="inner" @click.prevent="onPageClick(n)">{{n}}</a>
				</li>

				<li class="pagination-num-item" v-if="hasLast()">...</li>
				<li class="pagination-num-item" v-if="hasLast()">
					<a href="#" class="inner" @click.prevent="onPageClick(pageCount)">
						{{ pageCount }}
					</a>
				</li>
			</ul>

			<button class="arrow-btn arrow-btn-next" :class="{disable: !hasNextPage}" @click.prevent="onPageClick(value + 1)">
				<img class="inject-me" src="/assets/img/icons/arrow-right.svg" alt="arrow-left">
			</button>
		</template>
	</div>
</template>

<script>
	export default {
		props: {
			value: { type: Number, required: true },
			pageCount: { type: Number, required: true },
			urlFactory: { type: Function, required: false },
		},
		data() {
			return {
				pageRange: window.innerWidth > 767 ? 3 : 2
			};
		},
		computed: {
			pages() {
				var pages = [];

				for (var i = this.rangeStart; i <= this.rangeEnd; i++) {
					pages.push(i)
				}

				return pages;
			},
			rangeStart() {
				var start = this.value - this.pageRange;
				var end = this.value + this.pageRange;

				if (end > this.pageCount) {
					start = this.pageCount - this.pageRange * 2;
					start = start < 1 ? 1 : start;
				}

				if (start <= 1 || start == 2) {
					start = 1;
				}

				return start;
			},
			rangeEnd() {
				var start = this.value - this.pageRange;
				var end = this.value + this.pageRange;

				if (end > this.pageCount) {
					end = this.pageCount;
					start = this.pageCount - this.pageRange * 2;
					start = start < 1 ? 1 : start;
				}

				if (start <= 1) {
					end = Math.min(this.pageRange * 2 + 1, this.pageCount);
				}

				if (end == this.pageCount - 1) {
					end = this.pageCount;
				}

				return end;
			},
			hasPrevPage() {
				return this.value > 1;
			},
			hasNextPage() {
				return this.value < this.pageCount;
			}
		},
		methods: {
			hasFirst() {
				return this.rangeStart !== 1
			},
			hasLast() {
				return this.rangeEnd < this.pageCount
			},
			onPageClick(page) {
				if (page === this.value || page < 1 || page > this.pageCount) return;
				this.$emit("input", page);
			},
			getUrl(page) {
				if (!this.urlFactory) return '#!';
				return this.urlFactory(page);
			}
		}
	};
</script>
